import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalTrigger,
} from '@finn/design-system/atoms/modal';
import { Legal } from '@finn/design-system/icons/legal';
import { Features, useGetVariant } from '@finn/ua-featureflags';
import { interactionTrackingEvent, TrackingEventName } from '@finn/ua-tracking';
import { cn, useIntl } from '@finn/ui-utils';
import { MouseEvent, useState } from 'react';

export const PriceInformationB = ({ className, size }: Props) => (
  <div
    className={cn(
      '-mt-1 ml-1.5 font-light',
      size === 'small' ? 'text-[10px]' : 'text-xs',
      className
    )}
  >
    1
  </div>
);

export const PriceInformationC = ({ className }: Props) => {
  const i18n = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (ev: MouseEvent<unknown>) => {
    ev.stopPropagation();
    ev.preventDefault();
    setIsOpen(true);
    interactionTrackingEvent(TrackingEventName.MODAL_OPENED, {
      location: 'price_information',
    });
  };

  return (
    <div className={cn('mb-1.5 ml-2 flex', className)}>
      <Modal variant="small" onOpenChange={setIsOpen} open={isOpen}>
        <ModalTrigger asChild>
          <Legal onClick={handleClick} className="cursor-pointer" />
        </ModalTrigger>
        <ModalContent>
          <ModalHeader>
            <ModalTitle>
              {i18n.formatMessage('general.priceFootnote.title')}
            </ModalTitle>
          </ModalHeader>
          <p>{i18n.formatMessage('general.priceFootnote.text')}</p>
        </ModalContent>
      </Modal>
    </div>
  );
};

type Props = {
  className?: string;
  size?: 'small' | 'normal';
};
export const PriceInformation = (props: Props) => {
  const variant = useGetVariant(Features.ExpPriceInformation);

  if (variant === 'b') {
    return <PriceInformationB {...props} />;
  }

  if (variant === 'c') {
    return <PriceInformationC {...props} />;
  }

  return null;
};
